package navigation.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.tab.Tab
import com.essntl.core.utils.utils.update
import com.essntl.uikit.components.link.NavLinkState

@Composable
fun rememberNavLinks(navigator: Navigator?): List<NavLinkState> {
    if (navigator == null) return emptyList()

    var navItems by remember(navigator.items) {
        mutableStateOf(navigator.items.toNavLinks())
    }

    navigator.items.forEach { screen ->
        if (screen is NavLinkScreen)
            LaunchedEffect(screen.navLinkState) {
                navItems =
                    navItems.update(
                        predicate = { it.id == screen.navLinkState.id },
                        update = { screen.navLinkState },
                    )
            }
    }

    return navItems
}

fun Tab.toNavigator(): Navigator? =
    if (this is NavLinkTab)
        innerNavigator else
        null

fun List<Screen>.toNavLinks() = map { it.toNavLink() }

fun Screen.toNavLink() =
    if (this is NavLinkScreen)
        navLinkState
    else
        NavLinkState(
            title = this::class.simpleName ?: "Unknown",
        )